import { render, staticRenderFns } from "./FormToReceive.vue?vue&type=template&id=6c441d98&scoped=true&"
import script from "./FormToReceive.vue?vue&type=script&lang=js&"
export * from "./FormToReceive.vue?vue&type=script&lang=js&"
import style0 from "./FormToReceive.vue?vue&type=style&index=0&id=6c441d98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c441d98",
  null
  
)

export default component.exports